import * as React from 'react';
/**
 *
 * Original name: drag handle
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=26313%3A4342
 *
 */
export const DragHandleLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.248 7.962a2.023 2.023 0 1 0 0-4.046 2.023 2.023 0 0 0 0 4.046Zm5.505 0a2.023 2.023 0 1 0 0-4.046 2.023 2.023 0 0 0 0 4.046Zm-4.075 5.469a2.023 2.023 0 1 1-2.86-2.86 2.023 2.023 0 0 1 2.86 2.86Zm4.074.592a2.023 2.023 0 1 0 0-4.045 2.023 2.023 0 0 0 0 4.045Zm-4.074 5.385a2.023 2.023 0 1 1-2.86-2.86 2.023 2.023 0 0 1 2.86 2.86Zm4.074.592a2.023 2.023 0 1 0 0-4.045 2.023 2.023 0 0 0 0 4.045Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
